import { Component, ContentChild, Input, OnChanges, OnInit, Output, TemplateRef, EventEmitter } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { getBaseDialogData } from './base-dialog.data';
import { BaseDialogActionData, BaseDialogData } from './base-dialog.model';

@Component({
    selector: 'ifc-base-dialog',
    templateUrl: './base-dialog.component.html',
    styleUrls: ['./base-dialog.component.scss'],
    standalone: false
})
export class BaseDialogComponent implements OnInit, OnChanges {
  @Input() title?: string | SafeHtml;
  @Input() actions?: BaseDialogActionData[];

  @Output() actionClicked = new EventEmitter<BaseDialogActionData>();

  @ContentChild('content', { read: TemplateRef })
  contentRef: TemplateRef<unknown>;

  data: BaseDialogData;

  ngOnInit(): void {
    this.data = getBaseDialogData(this.title, this.actions);
  }

  ngOnChanges(): void {
    this.data = getBaseDialogData(this.title, this.actions);
  }

  onClickAction(action: BaseDialogActionData): void {
    this.actionClicked.emit(action);
  }
}
